require('./RAHireManagementPlanStep4.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

//@contact-center
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_AGREEMENT,
} = require('components/contactCenter/confirmScript/confirmationScript');
const { EVIDENCE_WEALTH_ROBO_HIRING } = require('constants/flagBasedFeatures');

//@core
const { formatText, FormattedText } = require('core/i18n').i18n;

//@constants
const {
    CHARGE_ACCOUNT_PREFIX,
    THIRD_STEP,
    FOURTH_STEP,
    FIRST_STEP,
    SECOND_STEP,
    EURO_SYMBOL,
} = require('constants/index');
const {
    RA_INVESTMENT_TYPE_FOUNDS,
    RA_HIRE_MANAGEMENT_PLAN_OPERATION_TYPE,
    CONTRIBUTION_PERIOD_MONTHLY,
} = require('../../../../raConstants/index');

//@components
const {
    SignaturePattern,
} = require('components/signaturePattern/signaturePattern');
const RAHireManagementPlanStep1 = require('../../../RAHireManagementPlan/RAHireManagementPlanStep1/RAHireManagementPlanStep1');
const RAHireManagementPlanStep2 = require('../../../RAHireManagementPlan/RAHireManagementPlanStep2/RAHireManagementPlanStep2');
const RAHireManagementPlanStep3 = require('../../../RAHireManagementPlan/RAHireManagementPlanStep3/RAHireManagementPlanStep3');
const RAHireFundTable = require('../../../../components/commons/RAHireFundTable/RAHireFundTable');

//@commons
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @utilities
const { formatDate } = require('utilities/dateHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { Portfolios } = require('../../../../utilities/RAPortfolioHelper');
const { getFormattedString } = require('utilities/currencyHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

class RAHireManagementPlanStep4 extends React.Component {
    componentDidMount() {
        const { validate, getHirePlanConfirmationPDF } = this.props;
        if (isPrintOfficeMode) {
            getHirePlanConfirmationPDF();
        }
        validate(FOURTH_STEP);
    }

    buildPurchaseSummaryMessage() {
        const {
            hasObjective,
            immSimulation,
            immProfile,
            immSteps,
        } = this.props;
        const investmentType = immSteps.getIn([FIRST_STEP, 'investmentType']);
        const fundsTable =
            investmentType === RA_INVESTMENT_TYPE_FOUNDS &&
            this.buildFundTableWithDescription();
        const clientName = PersonalDataHelper.getFullName(immProfile, false);
        const hasMonthlhyPeriodicity =
            immSteps.getIn([SECOND_STEP, 'periodicity']) ==
            CONTRIBUTION_PERIOD_MONTHLY;
        const monthlyContributionAmount =
            immSteps.getIn([SECOND_STEP, 'recurringContributionAmount']) || 0;
        const contributionDay = immSteps.getIn([
            SECOND_STEP,
            'contributionDay',
        ]);
        const accountNumber = immSteps.getIn([THIRD_STEP, 'selectedAccount']);
        const goalType =
            immSimulation.getIn(['simulation', 'type']) || 'others';
        const goalTypeText = formatText(
            `cc_raCustomPlanByObjective-${goalType}GoalType`,
        );
        const goalName = immSimulation.getIn(['simulation', 'name']);
        const investmentAmount = immSteps.getIn([
            FIRST_STEP,
            'investmentAmount',
        ]);
        const objectiveAmount =
            immSimulation.getIn(['simulation', 'amount']) || 0;
        const objectiveEndDate = formatDate(immSimulation.get('endDate'));
        const selectedPortfolioId = immSimulation.getIn([
            'simulation',
            'selectedPortfolio',
        ]);
        const strategyName =
            Portfolios[selectedPortfolioId] &&
            Portfolios[selectedPortfolioId].portfolioName;

        let monthlyContributionDetails, objectiveName;

        if (goalName) {
            objectiveName = (
                <div className="ra-hire-management-plan-step4__objective-box-info">
                    <FormattedText
                        value="cc_raCustomPlanByObjective-name"
                        injectedStrings={[goalName]}
                    />
                </div>
            );
        }

        if (hasMonthlhyPeriodicity) {
            monthlyContributionDetails = (
                <div className="ra-hire-management-plan-step4__contribution-box-wrapper">
                    <FormattedText value="cc_raCustomPlanByObjective-periodicContributionMonthly" />
                    <div className="ra-hire-management-plan-step4__contribution-box-info">
                        <FormattedText
                            value="cc_raCustomPlanByObjective-contributionAmount"
                            injectedStrings={[monthlyContributionAmount]}
                        />
                    </div>
                    <div className="ra-hire-management-plan-step4__contribution-box-info">
                        <FormattedText value="cc_raCustomPlanByObjective-monthlyContribution" />
                    </div>
                    <div className="ra-hire-management-plan-step4__contribution-box-info">
                        <FormattedText
                            value="cc_raCustomPlanByObjective-contributionDay"
                            injectedStrings={[contributionDay]}
                        />
                    </div>
                    <div className="ra-hire-management-plan-step4__contribution-box-info">
                        <FormattedText
                            value="cc_raCustomPlanByObjective-selectedAccount"
                            injectedStrings={[accountNumber]}
                        />
                    </div>
                </div>
            );
        }

        const objectiveDetails = (
            <div className="ra-hire-management-plan-step4__objective-box-wrapper">
                <FormattedText
                    className="ra-hire-management-plan-step4__objective-box-title"
                    value="cc_raCustomPlanByObjective-objectiveSectionTitle"
                />
                <div className="ra-hire-management-plan-step4__objective-box-info">
                    <FormattedText
                        value="cc_raCustomPlanByObjective-type"
                        injectedStrings={[goalTypeText]}
                    />
                </div>
                {objectiveName}
                <div className="ra-hire-management-plan-step4__objective-box-info">
                    <FormattedText
                        value="cc_raCustomPlanByObjective-amount"
                        injectedStrings={[objectiveAmount]}
                    />
                </div>
                <div className="ra-hire-management-plan-step4__objective-box-info">
                    <FormattedText
                        value="cc_raCustomPlanByObjective-initialContribution"
                        injectedStrings={[investmentAmount]}
                    />
                </div>
                <div className="ra-hire-management-plan-step4__objective-box-info">
                    <FormattedText
                        value="cc_raCustomPlanByObjective-objectiveEndDate"
                        injectedStrings={[objectiveEndDate]}
                    />
                </div>
            </div>
        );

        return (
            hasObjective && (
                <React.Fragment>
                    <FormattedText
                        className="ra-hire-management-plan-step4__mandatory-text-heading"
                        value="cc_raCustomPlanByObjective-mandatoryText"
                    />
                    <FormattedText
                        className="ra-hire-management-plan-step4__purchase-summary-detail"
                        value="cc_raCustomPlanByObjective-purchaseSummaryDetail"
                        injectedStrings={[clientName, strategyName]}
                    />
                    {fundsTable}
                    {objectiveDetails}
                    {monthlyContributionDetails}
                    <FormattedText
                        className="ra-hire-management-plan-step4__client-confirmation-text"
                        value="cc_raCustomPlanByObjective-clientConfirmationText"
                        injectedStrings={[clientName]}
                    />
                </React.Fragment>
            )
        );
    }

    buildFundTableWithDescription() {
        const {
            availableAccountsWithFunds,
            immProfile,
            immSimulation,
            immHireManagementPlan,
        } = this.props;
        const userFullName = immProfile.get('fullname');
        const fundsTotalAmount = immHireManagementPlan.get('fundsTotalAmount');
        const immSteps = immHireManagementPlan.get('steps');
        const selectedAccount = immSteps.getIn([FIRST_STEP, 'selectedAccount']);
        const amountObject = {
            amount: fundsTotalAmount,
            currency: EURO_SYMBOL,
        };
        const amountString = getFormattedString(amountObject);

        return (
            <div className="ra-hire-management-plan-step4__info">
                <FormattedText
                    className="ra-hire-management-plan-step4__cc-message"
                    value="cc_raHireManagementPlanStep4-paragraph2"
                />
                <div className="ra-hire-management-plan-step4__fund-table">
                    <RAHireFundTable
                        accountOwner={userFullName}
                        availableAccountsWithFunds={availableAccountsWithFunds}
                        fundsTotalAmount={fundsTotalAmount}
                        selectedAccount={selectedAccount}
                        selectedAccountsWithFunds={immHireManagementPlan.get(
                            'selectedAccountsWithFunds',
                        )}
                        filterSelectedAccounts={true}
                        showDetails={false}
                        showFooterOnly={true}
                        showAccountHeader={false}
                        hideProgressbar={true}
                        simulationAmount={immSimulation.getIn([
                            'simulation',
                            'initialContribution',
                        ])}
                    />
                </div>
                <div className="ra-hire-management-plan-step4__bold-text">
                    <FormattedText
                        value="cc_raHireManagementPlanStep4-paragraph3"
                        injectedStrings={[amountString]}
                    />
                    <FormattedText
                        className="ra-hire-management-plan-step4__cc-message"
                        value="cc_raHireManagementPlanStep4-paragraph4"
                    />
                </div>
            </div>
        );
    }

    render() {
        const {
            hasObjective,
            immAccounts,
            immProfile,
            immSimulation,
            flagBasedFeatures,
            immHireManagementPlan,
        } = this.props;
        const immSteps = immHireManagementPlan.get('steps');
        const accountNumber = immSteps.getIn([THIRD_STEP, 'selectedAccount']);
        const originProduct = immAccounts.getIn([
            'byId',
            accountNumber,
            'product',
        ]);
        const originNumber = immAccounts.getIn([
            'byId',
            accountNumber,
            'contractNumber',
        ]);
        const paramsForDms = {
            operationProcessId: immHireManagementPlan.get('operationProcessId'),
            evidenceType: 'SIGN_DOCUMENT',
        };
        const operationParams = {
            originAccount: `${CHARGE_ACCOUNT_PREFIX}${originProduct}${originNumber}`,
            ...(flagBasedFeatures.get(EVIDENCE_WEALTH_ROBO_HIRING) && {
                ...paramsForDms,
            }),
        };
        const operationType = RA_HIRE_MANAGEMENT_PLAN_OPERATION_TYPE;
        const purchaseSummaryMessage = this.buildPurchaseSummaryMessage();
        const userFullName = immProfile.get('fullname');
        const investmentType = immSteps.getIn([FIRST_STEP, 'investmentType']);
        const selectedPortfolioId = immSimulation.getIn([
            'simulation',
            'selectedPortfolio',
        ]);
        const strategyName =
            Portfolios[selectedPortfolioId] &&
            Portfolios[selectedPortfolioId].portfolioName;
        let purchasedWithText = formatText(
            'cc_raHireManagementPlanStep4-purchasedWithCash',
        );
        let fundsTable, raHireManagementPlanStep1;
        if (investmentType === RA_INVESTMENT_TYPE_FOUNDS) {
            purchasedWithText = formatText(
                'cc_raHireManagementPlanStep4-purchasedWithFund',
            );
            fundsTable = this.buildFundTableWithDescription();
        } else {
            const annualCost = immHireManagementPlan.get('annualCost');
            const productCost = immHireManagementPlan.get('productCost');

            raHireManagementPlanStep1 = (
                <div className="ra-hire-management-plan-step4__info">
                    <RAHireManagementPlanStep1
                        active={false}
                        immSteps={immSteps}
                        annualCost={annualCost}
                        productCost={productCost}
                    />
                </div>
            );
        }

        const purchaseSummaryDetailForPurePortfolio = !hasObjective && (
            <React.Fragment>
                <FormattedText
                    className="ra-hire-management-plan-step4__bold-text"
                    value="cc_raHireManagementPlanStep4-paragraph1"
                    injectedStrings={[
                        userFullName,
                        purchasedWithText,
                        strategyName,
                    ]}
                />
                {raHireManagementPlanStep1}
                {fundsTable}
                <div className="ra-hire-management-plan-step4__info">
                    <FormattedText value="cc_raCustomPlanByObjective-periodicContributionMonthly" />
                    <RAHireManagementPlanStep2
                        active={false}
                        immSteps={immSteps}
                        onAccountChange={() => {}}
                        onContributionDayChange={() => {}}
                        onPeriodicityChange={() => {}}
                        onRecurringContributionChange={() => {}}
                        validateCalendarStep={() => {}}
                    />
                </div>
                <div className="ra-hire-management-plan-step4__info">
                    <RAHireManagementPlanStep3
                        active={false}
                        immSteps={immSteps}
                        immAccounts={immAccounts}
                        immProfile={immProfile}
                        onAccountChange={() => {}}
                    />
                </div>
                <ConfirmationScript
                    confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}
                />
            </React.Fragment>
        );
        const PDFInbase64 = immHireManagementPlan.get('generatedPdf');
        const PDFInbase64Fetching = immHireManagementPlan.get('fetchingPdf');
        const PDFInbase64Error = immHireManagementPlan.get('errorOnPdf');
        return (
            <div className="ra-hire-management-plan-step4 no-print-out">
                <BlockInfo extraClass="ra-hire-management-plan-step4__cc-message">
                    {purchaseSummaryDetailForPurePortfolio}
                    {purchaseSummaryMessage}
                </BlockInfo>
                <SignaturePattern
                    printTitleValue="roboPrintTitle-gestionDiscretion"
                    customClassName="ra-hire-management-plan-step4__signature-pattern"
                    operationType={operationType}
                    operationParams={operationParams}
                    pdfToShow={PDFInbase64}
                    pdfToShowFetching={PDFInbase64Fetching}
                    pdfToShowError={PDFInbase64Error}
                />
            </div>
        );
    }
}

RAHireManagementPlanStep4.propTypes = {
    availableAccountsWithFunds: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immSimulation: PropTypes.object,
    immHireManagementPlan: PropTypes.object,
    validate: PropTypes.func.isRequired,
    clientName: PropTypes.string.isRequired,
    hasObjective: PropTypes.bool,
    immSteps: PropTypes.object.isRequired,
    annualCost: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    productCost: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    totalPeriodicContribution: PropTypes.number.isRequired,
    getHirePlanConfirmationPDF: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
};

module.exports = RAHireManagementPlanStep4;
